"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const variantContext = createContext("filled");
const useIconVariant = () => useContext(variantContext);
const IconVariantProvider = ({ variant, children }) => jsx(variantContext.Provider, { value: variant, children });
export {
  IconVariantProvider,
  useIconVariant
};
